module.exports = __webpack_public_path__ + "static/img/10036.74b73ad5.png";